import { Breadcrumb, Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams, useNavigate } from "react-router-dom";

import { Loading } from "components";
import IconArrowBack from "components/Icons/IconArrowBack/IconArrowBack";
import { AssignmentDetailPractice } from "features";
import { SessionHistoryAssignmentDetailHeader } from "components/AssignmentDetailHeader/SessionAssignmentDetailHeader";

import { useUserAssignmentDetail } from "utils/hooks/useUserAssignmentDetail";

const SessionDetailPage = () => {
  const { t } = useTranslation(["history"]);
  const { sessionId, userAssignmentId } = useParams();

  const navigate = useNavigate();

  const { assignmentData, isLoading, isUnavailable, title } = useUserAssignmentDetail(userAssignmentId);

  // AIDEV-NOTE: Kontrola parametrů musí být pod všemi hooky, jinak se při změně parametrů změní jejich počet. [TD-487]
  if (!sessionId || !userAssignmentId) return null;

  const navigateAssignment = (newAssignmentId: string) => {
    navigate(`/historie/cviceni/${sessionId}/${newAssignmentId}`);
  };
  return (
    <>
      <div className={"page-header page-header--has-tabs"}>
        <Container className={"container-mw-md"}>
          <Breadcrumb>
            <li className={"breadcrumb-item"}>
              <Link to="/historie">
                <IconArrowBack />
                {t("back", { ns: "common" })}
              </Link>
            </li>
          </Breadcrumb>

          <SessionHistoryAssignmentDetailHeader
            assignmentId={assignmentData?.assignment?.id ?? ""}
            userAssignmentId={userAssignmentId}
            sessionId={sessionId}
            onNavigate={navigateAssignment}
            title={title}
          />
        </Container>
      </div>

      {isLoading ? (
        <Loading />
      ) : (
        <AssignmentDetailPractice
          assignment={assignmentData}
          userAssignmentId={userAssignmentId}
          isUnavailable={isUnavailable}
        />
      )}
    </>
  );
};

export default SessionDetailPage;
